import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { IconButton, InputPicker, Panel, PanelGroup, Radio, RadioGroup, Stack, Text } from 'rsuite';
import {
  MdOutlineSettings as IconSettings,
  MdDirectionsRun as IconRun,
  MdOutlineAddCircle as IconMore,
  MdOutlineRemoveCircle as IconLess,
  MdOutlineInfo as IconInfo,
} from 'react-icons/md';

import {
  offOnAutoOptions,
  DisableEnableOptions,
  runOnceTimerOptions,
  SocketTypesSelect,
  ValveTypesSelect,
  VFTypesSelect,
  offOnOptions,
} from '../constants';
import { getClosestRunOnInterval, getRunonStartStopTimesForInterval, isALight, isASanitiser } from './Common';
import { DisplayIcon } from './DisplayIcon';
import { DisplayItem } from './DisplayItem';
import { Display2ValueToggleItemNonPaneled } from './Display2ValueToggleItem';
import { DisplayLightSettingsNonPaneled } from './DisplayLightSettings';
import { devLog } from '../utils/devLog';

export const DisplaySocketValveVFStatusItem = ({
  mode_register,
  status_register,
  name_register,
  type_register,
  run_once_enable_reg,
  run_once_start_reg,
  run_once_stop_reg,
  icon,
  tc,
  disabled,
  socket_setting,
  onChange,
  displayType,
  borderOff,
  duty_cycle_status_reg,
  duty_cycle_secs_reg,
}) => {
  const [modeValue, setModeValue] = useState(0);
  const [runOnceValue, setRunOnceValue] = useState(0);
  const [showMore, setShowMore] = useState(false);

  const updateModeValue = (theValue, event) => {
    devLog('Updated Mode Value', event);
    setModeValue(theValue);
    onChange(mode_register, theValue, true);
  };

  const updateRunOnceTime = (theValue, event) => {
    setRunOnceValue(theValue);
    devLog('the Interval', theValue);
    let interval = getRunonStartStopTimesForInterval(theValue);
    onChange(run_once_start_reg, interval.start);
    onChange(run_once_stop_reg, interval.stop);
  };

  const isNameSet = () => {
    var return_value = true;
    devLog('name', name_register);
    if (
      name_register === undefined ||
      name_register.display === '' ||
      name_register.display ===
        '\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000'
    ) {
      return_value = false;
    }
    return return_value;
  };

  /** @returns {'green' | 'red' | 'orange'} */
  const getFormattedTextColor = () => {
    var return_value = /** @type {'green' | 'red' | 'orange'} */ ('green');
    if (status_register.display === 'ON') {
      return_value = 'green';
    } else if (status_register.display === 'OFF') {
      return_value = 'red';
    } else {
      return_value = 'orange';
    }
    return return_value;
    // (?(<Text className="align-middle" color="green"><Bold>{status_register.display}</Bold> </Text>):(status_register.display==='OFF'?(<Text color="red"><Bold>{status_register.display}</Bold> </Text>):<Text color="orange" ><Bold>{status_register.display}</Bold> </Text>))
  };

  const getNameString = () => {
    var name = '';
    if (isNameSet()) {
      name = name_register.display;
    } else {
      // Truthiness, not `!== undefined` as before: the old guard let a null through to
      // `type_register.value` and threw. Unreachable via the only producer — getRegisterData is
      // an Array.find, which yields undefined and never null — so this is consistency with the
      // null-safe isALight/isASanitiser below, not a live crash. type_register is a register
      // object or absent; it is never a falsy non-null value.
      if (type_register) {
        // Matched on value, not by array position. These tables happen to be ordered so that
        // index === value, so indexing worked — but a value the table does not carry made
        // `undefined.label` throw and took the whole view down, rather than simply leaving the
        // heading blank. A firmware type this app has not been taught is exactly that case.
        const options = { VALVE: ValveTypesSelect, SOCKET: SocketTypesSelect, VF: VFTypesSelect }[displayType];
        name = options?.find((option) => option.value === type_register.value)?.label ?? '';
      }
    }
    return name;
  };

  useEffect(() => {
    const convertRunOnceToValue = () => {
      const interval = getClosestRunOnInterval(run_once_start_reg.value, run_once_stop_reg.value);
      setRunOnceValue(interval.value);
    };
    convertRunOnceToValue();
  }, [run_once_start_reg, run_once_stop_reg]);

  useEffect(() => {
    setModeValue(mode_register.value);
    // console.log("Mode Value for:" + mode_register.title + " set to:",mode_register.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode_register]);

  return (
    <PanelGroup bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Panel
        bordered={true}
        style={{ backgroundColor: 'white' }}
        header={
          <Stack justifyContent="space-between">
            <span>{status_register.title}</span>

            <IconButton
              appearance="primary"
              color="blue"
              size="sm"

              icon={showMore ? <IconLess /> : <IconMore />}
              onClick={() => setShowMore(!showMore)}
            />
          </Stack>
        }
      >
        <Flex justifyContent="start" className="space-x-4 align-middle">
          <DisplayIcon icon={icon} />
          <Flex justifyContent="between" className="space-x-4 align-middle">
            <Flex justifyContent="start">
              <Text color={tc} className="truncate">
                {' '}
                <Bold>{getNameString()}</Bold>
              </Text>
              <Text color={getFormattedTextColor()}>
                <Bold>{status_register.display}</Bold>{' '}
              </Text>

              {/* {(status_register.display==='ON'?(<Text className="align-middle" color="green"><Bold>{status_register.display}</Bold> </Text>):(status_register.display==='OFF'?(<Text color="red"><Bold>{status_register.display}</Bold> </Text>):<Text color="orange" ><Bold>{status_register.display}</Bold> </Text>))} */}
            </Flex>

            <Text color={tc}>
              <Bold>Mode:</Bold>
            </Text>
            <RadioGroup
              name={`radioList-${mode_register.address}`}
              inline
              appearance="picker"
              onChange={updateModeValue}
              value={modeValue}
            >
              {offOnAutoOptions.map((item) => (
                <Radio key={item.value + 1} value={item.value} disabled={disabled}>
                  {' '}
                  {item.label}{' '}
                </Radio>
              ))}
            </RadioGroup>
          </Flex>
        </Flex>
      </Panel>

      {isALight(type_register) && displayType === 'SOCKET' && showMore && (
        <Panel bordered={true} style={{ backgroundColor: 'white' }}>
          <DisplayLightSettingsNonPaneled
            register={socket_setting}
            tc={tc}
            icon={IconSettings}
            onChange={onChange}
            lightNumber={type_register.light_number}
            disabled={disabled}
            ignoreBrand={true}
          />
        </Panel>
      )}
      {isASanitiser(type_register) && displayType === 'SOCKET' && showMore && (
        <Panel bordered={true} style={{ backgroundColor: 'white' }}>
          <Display2ValueToggleItemNonPaneled
            icon={IconInfo}
            tc={tc}
            register={duty_cycle_status_reg}
            options={offOnOptions}
            disabled={true}
            onChange={onChange}
          />
          <DisplayItem register={duty_cycle_secs_reg} icon={IconInfo} borderOff={true} />
        </Panel>
      )}

      {showMore && (
        <Panel bordered={true} style={{ backgroundColor: 'white' }}>
          <Flex justifyContent="start" className="space-x-4">
            <DisplayIcon icon={IconRun} />
            <Text color={tc}>
              <Bold>Run Once:</Bold>
            </Text>
            <div
              className="truncate w-1/2 space-y-1"
              style={{
                display: 'block',
                width: '100%',
              }}
            >
              <Flex justifyContent="end" className="space-x-4">
                <InputPicker
                  block
                  cleanable={false}
                  searchable={false}
                  placement="autoVerticalStart"
                  data={runOnceTimerOptions}
                  value={runOnceValue}
                  onChange={updateRunOnceTime}
                  style={{ width: 224 }}
                  disabled={disabled}
                />
              </Flex>
            </div>
          </Flex>
        </Panel>
      )}
      {showMore && (
        <Panel bordered={true} style={{ backgroundColor: 'white' }}>
          <Flex justifyContent="start" className="space-x-4">
            <Display2ValueToggleItemNonPaneled
              icon={IconRun}
              tc={tc}
              register={run_once_enable_reg}
              options={DisableEnableOptions}
              disabled={disabled}
              onChange={onChange}
            />
          </Flex>
        </Panel>
      )}
    </PanelGroup>
  );
};
